import PageLoading from '@/components/page-loading';
import loadable from '@loadable/component';
export default [
    {
        path: '/admin/:type?',
        component: loadable(() => import(/* webpackChunkName: "home" */ `@/views/admin`), { fallback: <PageLoading /> }),
    },
] as ReactRoute[];
